import React from "react";

import T from 'i18n-react';
import Moment from 'moment-timezone';
import { PieChart, Pie, Cell } from 'recharts';

import "react-circular-progressbar/dist/styles.css";

export class StatusPieChart extends React.Component {
    render() {
        const { appContext: { theme } } = this.props;
        const scale = (this.props.height || 240) / 240;
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                margin: 'auto',
                minHeight: this.props.height || 240,
                height: this.props.height || 450
            }}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.props.onClick(true) }}>
                <PieChart style={{ margin: 'auto', paddingTop: 20 }} width={120 * scale} height={120 * scale}>
                    <Pie data={this.props.graphData}
                        isAnimationActive={false}       // BUG in the library, labels will not display at all times if the animations are enabled
                        dataKey='value'
                        label={(e) => e.name}
                        labelLine={false}
                        innerRadius={37}
                        outerRadius={52}
                        fill='#8884d8'
                        paddingAngle={5}>
                        {
                            this.props.graphData.map((entry, index) => {
                            return <Cell 
                                key={`Cell.${index}`} 
                                fill={entry.color} 
                                fillOpacity={entry.opacity || 1} 
                                stroke={entry.today ? "#000000" : undefined}
                                strokeWidth={entry.today ? 1 : 0}
                                outlineColor="#000000"
                                />;
                            })
                        }
                    </Pie>
                </PieChart>
                <div style={{ paddingLeft: 20, paddingRight: 20, paddingBottom: 20, display: 'flex', alignContent: 'space-between', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ width: 20 }}></div>
                    <div>
                        <T.div style={{ color: theme.palette.text.secondary, fontSize: 13 }} text={{ key: 'weekOf', startTime: Moment(this.props.startTime).format("M/D/YYYY") }} />
                        {this.props.timeSince ? <T.div style={{ color: theme.palette.text.primary, fontSize: 11 }} text={{ key: 'lastCheckIn', timeSince: this.props.timeSince }} /> : <T.div text='noRecentCheckIn' />}
                    </div>
                    <div style={{ width: 20 }}></div>
                </div>
            </div>
        )
    }
}
